const isIpv4 = (value) => /^(\d{1,3}\.){3}\d{1,3}$/.test(String(value || "").trim());

export async function fetchPublicIpv4Meta() {
  try {
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    const ipPayload = await ipResponse.json();
    const ipv4 = String(ipPayload?.ip || "").trim();
    if (!isIpv4(ipv4)) {
      return { ipv4Address: "", state: "", country: "" };
    }

    const geoResponse = await fetch(`https://ipapi.co/${encodeURIComponent(ipv4)}/json/`);
    const geoPayload = await geoResponse.json();

    return {
      ipv4Address: ipv4,
      state: String(geoPayload?.region || geoPayload?.region_code || "").trim(),
      country: String(geoPayload?.country_name || "").trim()
    };
  } catch {
    return { ipv4Address: "", state: "", country: "" };
  }
}

